module.exports = __webpack_public_path__ + "img/9788954619561.ce1abf97.jpg";